import Api from "utils/api";

export const fetchNotifications = async () => {
  return Api.get(`/notification/notification/user-notifications/`).then((res) => res.data);
};

export const setReadAll = async () => {
  return Api.get(`/notification/notification/read-all`).then((res) => res.data);
};
